import { render, staticRenderFns } from "./customer_list.vue?vue&type=template&id=1a3bf5e5&scoped=true"
import script from "./customer_list.vue?vue&type=script&lang=js"
export * from "./customer_list.vue?vue&type=script&lang=js"
import style0 from "./customer_list.vue?vue&type=style&index=0&id=1a3bf5e5&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3bf5e5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a3bf5e5')) {
      api.createRecord('1a3bf5e5', component.options)
    } else {
      api.reload('1a3bf5e5', component.options)
    }
    module.hot.accept("./customer_list.vue?vue&type=template&id=1a3bf5e5&scoped=true", function () {
      api.rerender('1a3bf5e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/terminal_stop_apply/form/customer_list.vue"
export default component.exports